import styled from "styled-components";

import { ChartTooltipContainer } from "common/ui/Tooltip/Tooltip.elements";
export { LabelWithCircleContainer } from "common/ui/ChartLegends/LabelWithCircle.elements";

export const PieChartTooltipContainer = styled(ChartTooltipContainer)`
  display: flex;
  align-items: center;
  
  .tooltip__inner {
    left: 0;
    top: -12px;
    transform: translate(-50%, -100%);
    position: absolute;
     
  }
`
export const PieChartContainer = styled.div`
  position: relative;
  min-height: 200px;
  max-height: 200px;
  width: 100%;

  &:hover {
    [data-id="chart-tooltip"] {
      visibility: visible;
    }
  }

  &:hover {
    .slice { 
      transition: d .2s; 
    }
  }

  .slice {
    transition: fill .2s;
    &:not(.is-hovered) {
      &.is-not-selected {
        fill: #eee !important;
      }
    }
  }
  
  .tooltip__title {
    width: 100%;
  }
`


export const PieChartWidgetMain = styled.div<{gridRows?: string}>`
  display: grid;
  grid-template-rows:auto 1fr;
 
  padding-top: 0;

  
`